/**
 * This service provides the ability to transform a error-response message structure provided by the
 * current CAT-WebAPI in a typed form to be used by components to further display the error-details to the user.
 */
import {Injectable} from '@angular/core';
import {ApiErrorDetail, ApiErrorInfo} from '@catcore/web-api-error/types';
import {Message} from '@catui/components/alert/types';
import {isNullOrUndefined} from 'util';

@Injectable()
export class WebApiErrorService {
  buildFromJsonResponse(errorInfo: ApiErrorInfo): Message[] {
    const messages: Message[] = [];

    errorInfo.errors.forEach((errorDetailInfo: ApiErrorDetail) => {
      const factory = getFactoryForError(errorDetailInfo);
      messages.push(factory());
    });
    return messages;
  }
}

/**
 * Builder for type csv_units_not_added
 */
const csvUnitsNotAddedFactory = (errorDetailInfo: ApiErrorDetail): any => {
  const factory = () => {
    const errorInfo: Message = {
      title: errorDetailInfo.error_message,
      description: null,
      messages: [],
    };

    if (!isNullOrUndefined(errorDetailInfo['part_numbers'])) {
      const partNumbers = errorDetailInfo['part_numbers'];
      partNumbers.forEach((errorDetail) => errorInfo.messages.push({title: null, description: errorDetail}));
    }

    return errorInfo;
  };
  return factory;
};

const getFactoryForError = (errorInfo: ApiErrorDetail): any => {
  let factory = () => {
  };
  if (Object.keys(ERROR_CONVERTERS).includes(errorInfo.error_type)) {
    factory = ERROR_CONVERTERS[errorInfo.error_type](errorInfo);
  }
  return factory;
};

const ERROR_CONVERTERS = {
  csv_units_not_added: csvUnitsNotAddedFactory,
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/web-api-error/services/web-api-error.service.ts